var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 상세정보 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { infoPop, itemInfoState, reLoad, reLoadPage, reLoadState, userInfoLoginState, } from "../../../../recoil/userState";
// utils
import { alertState, checkTypeState, curSchduleTreeState } from "../../../../recoil/assessmentState";
import { loadingBoxState } from "../../../../recoil/menuState";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import * as CONST from "../../../../utils/Const";
import { useDebounceEffect } from "./InspectionList";
// datepicker
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { enUS, ko } from "date-fns/esm/locale";
import { langId, langState } from "../../../../recoil/langState";
import { useTrans } from "../../../../utils/langs/useTrans";
import ConfirmPop from "../../../common/popup/ConfirmPop";
function InspectionInfo(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const curTree = useRecoilValue(curSchduleTreeState);
    const [reload, setReload] = useRecoilState(reLoadPage);
    const [infoPopId, setInfoPopId] = useRecoilState(infoPop);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [reloadState, setReloadState] = useRecoilState(reLoadState);
    const langs = useRecoilValue(langState); // 다국어
    const langIds = useRecoilValue(langId);
    // props
    const { handleOpenPop, itemId, closePopup } = props;
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        else {
            setMobile(false);
        }
    }), 100);
    // useState
    const [itemInfo, setItemInfo] = useState(null);
    const [checkItemList, setCheckItemList] = useState([]);
    const [infoOpen, setInfoOpen] = useState(false);
    const [checkOpen, setCheckOpen] = useState(0);
    const [checkEctOpen, setCheckEctOpen] = useState(0);
    const [popReset, setPopreset] = useState(false);
    const [checkEdit, setCheckEdit] = useState(null);
    const [checkChange, setCheckChange] = useState(false);
    const [listCount, setListCount] = useState(5);
    const [reportList, setReportList] = useState([]);
    const [editReload, setEditReload] = useState(false);
    const [popItem, setPopItem] = useState(null);
    const [spgInfo, setSpgInfo] = useState([]);
    // 상세 정보 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/item/${itemId.id}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: itemId.id + itemId.type + reload + reloadState + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum === CONST.API_200) {
                setItemInfo(data.body);
            }
        }
    }, [data, itemId.id, reloadState, langIds]);
    // 체크리스트 API
    const { data: checkData } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/schedules?itemId=${itemId.id}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: itemId.id + itemId.type + reload + reloadState + langIds,
    });
    useEffect(() => {
        if (checkData) {
            if (checkData.codeNum === CONST.API_200) {
                setListCount(5);
                setCheckItemList(checkData.body);
            }
            else {
                /*  setAlert({
                   ...alert,
                   type: CONST.TYPE_NONE,
                   divTag: data.errorList.map((err) => (err.msg))
                 });
                 CUTIL.jsopen_AlertPopup(CONST.POP_ALERT); */
            }
        }
    }, [checkData, reloadState, reload, langIds]);
    // 상세 정보 접고 펼치기
    function InfoOpen(e) {
        if (infoOpen == false) {
            setInfoOpen(true);
        }
        else {
            setInfoOpen(false);
        }
    }
    // 진단 점검 상세 페이지
    function CheckListOpen(e, item) {
        e.preventDefault();
        if (item.scheduleId !== checkOpen) {
            setCheckOpen(item.scheduleId);
        }
        else {
            setCheckOpen(0);
        }
    }
    useEffect(() => {
        // 상세 정보 수정
        handleOpenPop("pop-s-edit", _jsx(UpdatePop, { curTree: curTree, popItem: popItem, spgInfo: spgInfo, itemId: itemId, editReload: editReload, setEditReload: setEditReload, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => DivceClose("pop-s-edit") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
        // 일정 등록
        handleOpenPop("pop-ss-add", _jsx(ItemPop, { isMobile: isMobile, curTree: curTree, itemId: itemId, popReset: popReset, setPopreset: setPopreset, handleOpenPop: handleOpenPop, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ItemPopClose("pop-s-add") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
        //진단 점검 수정
        handleOpenPop("pop-check-edit", _jsx(ChechItemUpdatepop, { isMobile: isMobile, curTree: curTree, checkEdit: checkEdit, checkChange: checkChange, setCheckEdit: setCheckEdit, setCheckChange: setCheckChange, htmlClose: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => EditClose("pop-check-edit") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) }));
        //삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, { checkEdit: checkEdit }));
    }, [curTree, popItem, spgInfo, editReload, popReset, checkEdit, checkChange]);
    function DivceClose(id) {
        setEditReload(true);
        CUTIL.jsclose_Popup(id);
    }
    // 수정 팝업
    function EditPop(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setPopItem(itemInfo);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/${curTree.company.companyId}/spgs`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSpgInfo(data.body);
                    setPopreset(false);
                    CUTIL.jsopen_Popup(e);
                }
                else {
                }
            }
        });
    }
    // 일정 추가하기 팝업
    function SchdulerAddPop(e) {
        setPopreset(false);
        CUTIL.jsopen_Popup(e);
    }
    // 팝업 닫기
    function ItemPopClose(id) {
        CUTIL.jsclose_Popup(id);
        setPopreset(true);
    }
    // 진단 점검 하기 수정 삭제 레이어 팝업
    function typeBox(item) {
        if (item.scheduleId !== checkEctOpen) {
            setCheckEctOpen(item.scheduleId);
            setCheckEdit(item);
            setCheckChange(true);
        }
        else {
            setCheckEctOpen(0);
            setCheckChange(false);
        }
    }
    // 수정, 삭제 팝업
    function EditClose(id) {
        CUTIL.jsclose_Popup(id);
        setCheckChange(false);
        setCheckEdit(null);
    }
    //삭제 수정 레이블 팝업
    function CheckPop(e) {
        setCheckEctOpen(0);
        CUTIL.jsopen_Popup(e);
    }
    // 진단 점검 하기 버튼
    function CheckOn(e, item) {
        return __awaiter(this, void 0, void 0, function* () {
            closePopup(infoPopId);
            setCheck(Object.assign(Object.assign({}, check), { checkType: "inspetion", checkOn: true, nextStep: "step3", schdeulerId: item.scheduleId, itemInfo: {
                    id: itemId.id,
                    itemId: itemId.itemId,
                    itemName: itemInfo.panelName,
                    panelName: itemInfo.panelName,
                    serialNo: itemInfo.serialNo,
                    spgId: itemInfo.companySpgId,
                }, dueDate: item.dueDate, chekVersionTypeInfo: {
                    checkVersionId: item.checkVersionId,
                    versionNo: "",
                }, inspector: item.inspector, disabled: true }));
        });
    }
    // 지금 점검하기 버튼
    function CheckOnStart(e) {
        closePopup(infoPopId);
        setCheck(Object.assign(Object.assign({}, check), { checkType: "inspetion", checkOn: true, nextStep: "step1", preStep: "", itemInfo: {
                id: itemId.id,
                itemId: itemId.itemId,
                itemName: itemInfo.panelName,
                panelName: itemInfo.panelName,
                serialNo: itemInfo.serialNo,
                spgId: itemInfo.companySpgId,
            }, dueDate: "" }));
    }
    // 더보기 이벤트
    function ListCount(num) {
        if (checkItemList.length - num > 5) {
            setListCount(num + 5);
        }
        else {
            setListCount(num + (checkItemList.length - num));
        }
    }
    // report 목록
    const { data: reportData } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/item/reports`,
        appQuery: {
            langId: langIds,
            itemIdPk: itemId.id,
        },
        userToken: userInfo.loginInfo.token,
        watch: itemId.id + langIds.toString(),
    });
    useEffect(() => {
        if (reportData) {
            if (reportData.codeNum === CONST.API_200) {
                setReportList(reportData.body);
            }
            else {
            }
        }
    }, [reportData, langIds]);
    function ReportDownLoad(item) {
        let fileName = itemInfo.itemName + "_" + dayjs(item.updatedTime).format("YYYY-MM-DD") + `_${t("라벨.진단점검리포트")}.PDF`;
        HTTPUTIL.fileDownload(fileName, item.url);
    }
    // 수정 삭제 레이블 이외 다른곳 클릭 이벤트
    useEffect(() => {
        const handleClick = (e) => {
            // e.preventDefault();
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("btn-etc") || targetElement.closest(".btn-etc");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".popup-etc");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("open");
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    return (_jsx(_Fragment, { children: itemInfo && (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "box__header" }, { children: [_jsx("p", Object.assign({ className: "box__title" }, { children: itemInfo.itemName ? itemInfo.itemName : "-" })), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => closePopup("m-1650") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsxs("section", { children: [_jsxs("div", Object.assign({ className: "section-top mb-8" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.설비정보") })), _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-s-edit", onClick: (e) => EditPop(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) }))] })), _jsxs("div", Object.assign({ className: "section-bottom" }, { children: [_jsx("div", Object.assign({ className: `tbl-list row fold-list ${infoOpen ? "open" : ""}` }, { children: _jsxs("table", Object.assign({ summary: "\uD615\uBA85,\uD310\uB12C \uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uC81C\uC870\uC0AC,\uC81C\uC870\uB144\uC6D4,\uBD84\uC804\uC18C \uBA85,\uC815\uACA9\uC804\uC555,2\uCC28 \uC804\uC555,\uC815\uACA9\uC804\uB958,\uCC28\uB2E8\uC804\uB958,\uC815\uACA9\uC6A9\uB7C9 \uD56D\uBAA9\uC73C\uB85C \uC124\uBE44 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC124\uBE44 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "40%" } }), _jsx("col", { style: { width: "60%" } })] }), _jsxs("tbody", { children: [_jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.설비유형") })), _jsx("td", { children: itemInfo.spgName ? itemInfo.spgName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.분전소명") })), _jsx("td", { children: itemInfo.roomName ? itemInfo.roomName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.형명") })), _jsx("td", { children: itemInfo.itemName ? itemInfo.itemName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.판넬명") })), _jsx("td", { children: itemInfo.panelName ? itemInfo.panelName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.시리얼번호") })), _jsx("td", { children: itemInfo.serialNo ? itemInfo.serialNo : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.제조사") })), _jsx("td", { children: itemInfo.manufacturer ? itemInfo.manufacturer : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.제조년월") })), _jsx("td", { children: itemInfo.madeyyyyMM ? dayjs(itemInfo.madeyyyyMM).format("YYYY-MM") : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.전력설비노후도") })), _jsx("td", { children: itemInfo.itemAgeScore ? itemInfo.itemAgeScore : "-" })] }), itemInfo.elecInfo.map((list, idx) => (_jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "row" }, { children: [list.name, _jsx("br", {}), "(", list.code, ")"] })), _jsxs("td", { children: [list.value == null ? "-" : list.value, " ", list.unit, " "] })] }, "infos_" + idx.toString()))), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.설비메모") })), _jsx("td", { children: itemInfo.memo ? itemInfo.memo : "-" })] })] })] })) })), _jsx("button", Object.assign({ type: "button", className: `btn btn-open ${infoOpen ? "close" : ""}`, onClick: (e) => InfoOpen(e) }, { children: _jsx("span", { children: infoOpen ? t("라벨.닫기") : t("라벨.더보기") }) }))] }))] }), _jsxs("section", { children: [_jsxs("div", Object.assign({ className: "section-top" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.진단점검") })), _jsxs("div", Object.assign({ className: "color-info" }, { children: [_jsx("p", Object.assign({ className: "ehc" }, { children: t("스케쥴.캘린더.LS") })), _jsx("p", Object.assign({ className: "etc" }, { children: t("스케쥴.캘린더.고객향점검") }))] }))] })), checkItemList.length - listCount > 0 && (_jsxs("div", Object.assign({ className: "flex-inline right mt-4 mb-4" }, { children: [_jsxs("span", Object.assign({ className: "font-14 txt-middlegray" }, { children: ["+ ", checkItemList.length - listCount] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic p-0 ml-8 bg-no", onClick: (e) => ListCount(listCount) }, { children: _jsx("span", { children: t("라벨.더보기") }) }))] }))), _jsx("div", Object.assign({ className: "section-bottom box-shadow no-data" }, { children: _jsxs("div", Object.assign({ className: "title" }, { children: [_jsx("a", Object.assign({ href: "#", className: "click", onClick: (e) => e.preventDefault() }, { children: _jsx("p", { children: t("라벨.설비점검하세요") }) })), _jsxs("div", Object.assign({ className: "flex-inline right" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn", onClick: (e) => CheckOnStart(e) }, { children: _jsx("span", { children: t("라벨.지금점검하기") }) })), _jsx("button", Object.assign({ type: "button", className: "btn js-open", "data-pop": "pop-ss-add", onClick: (e) => SchdulerAddPop(e) }, { children: _jsx("span", { children: t("라벨.일정추가하기") }) }))] }))] })) }))] }), _jsxs("section", { children: [_jsx("div", Object.assign({ className: "section-top" }, { children: _jsxs("p", Object.assign({ className: "tit" }, { children: ["Reports", _jsxs("span", Object.assign({ className: "txt-info m-none" }, { children: ["* ", t("라벨.레포트내역정보")] }))] })) })), _jsx("div", Object.assign({ className: `section-bottom ${reportList.length <= 0 ? "nodata" : ""}` }, { children: _jsxs("div", Object.assign({ className: "tbl-list row" }, { children: [_jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("라벨.Reports가없습니다") })), _jsxs("table", Object.assign({ summary: "\uD615\uBA85,\uD310\uB12C \uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uC81C\uC870\uC0AC,\uC81C\uC870\uB144\uC6D4,\uBD84\uC804\uC18C \uBA85,\uC815\uACA9\uC804\uC555,2\uCC28 \uC804\uC555,\uC815\uACA9\uC804\uB958,\uCC28\uB2E8\uC804\uB958,\uC815\uACA9\uC6A9\uB7C9 \uD56D\uBAA9\uC73C\uB85C \uC124\uBE44 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC124\uBE44 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "40%" } }), _jsx("col", { style: { width: "60%" } })] }), _jsx("tbody", { children: reportList.map((report, idx) => (_jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: report.checkTypeName })), _jsx("td", { children: _jsx("ul", Object.assign({ className: "filelist" }, { children: _jsx("li", Object.assign({ className: `${report.url == null ? "no-file" : ""}` }, { children: _jsx("span", Object.assign({ style: { cursor: report.url == null ? "default" : "pointer" }, onClick: (e) => report.url && ReportDownLoad(report) }, { children: dayjs(report.updatedTime).format("YYYY-MM-DD") })) })) })) })] }, "report_" + idx.toString()))) })] }))] })) }))] })] }))] })) }));
}
export default InspectionInfo;
function UpdatePop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const setReload = useSetRecoilState(reLoad);
    const setReloadState = useSetRecoilState(reLoadState);
    const langIds = useRecoilValue(langId);
    // props
    const { curTree, popItem, spgInfo, editReload, setEditReload, itemId } = props;
    // useState
    const [spg, setSpg] = useState(null);
    const [itemName, setItemName] = useState("");
    const [panelName, setPanelName] = useState("");
    const [serialNo, setSerialNo] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [memo, setMemo] = useState("");
    const [today, setToday] = useState("");
    const [file, setFile] = useState([]);
    const [updateFile, setUpdateFile] = useState([]);
    const [elecInfo, setEleInfo] = useState([]);
    const [elecInfoItem, setEleInfoItem] = useState([]);
    const [errorList, setErrorList] = useState([]);
    const lastNum = 10;
    useEffect(() => {
        if (elecInfoItem.length > 0) {
            const listArr = elecInfo.concat(elecInfoItem[0]).sort((a, b) => (a.sort > b.sort ? 1 : -1));
            const elecInfoListArr = (data) => {
                const uniqueItems = new Set();
                return data.filter((item) => {
                    const itemString = JSON.stringify(item);
                    if (uniqueItems.has(itemString)) {
                        return false;
                    }
                    else {
                        uniqueItems.add(itemString);
                        return true;
                    }
                });
            };
            // 중복 제거된 데이터
            const uniqueData = elecInfoListArr(listArr);
            setEleInfo(uniqueData);
        }
    }, [elecInfoItem.length]);
    // spg select
    useEffect(() => {
        if (popItem) {
            // setSpg(itemInfo.spgName);
            setItemName(popItem.itemName);
            setPanelName(popItem.panelName);
            setSerialNo(popItem.serialNo);
            setManufacturer(popItem.manufacturer);
            setMemo(popItem.memo);
            setToday(popItem.madeyyyyMM ? popItem.madeyyyyMM : "");
            setErrorList([]);
            setEleInfo([]);
            setEleInfoItem([]);
            Images(popItem.itemId);
            setEditReload(false);
        }
        if (spgInfo.length > 0) {
            let spgItem = spgInfo.filter((vals) => vals.companySpgId == popItem.companySpgId);
            onClickSpg(spgItem[0], popItem.elecInfo);
        }
        CUTIL.ClassNameScrollIntoView("form__input");
    }, [popItem, spgInfo, curTree, editReload, langIds]);
    function Images(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/images/item?itemId=${itemId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setUpdateFile(data.body);
                }
                else {
                    // need error handle
                }
            }
        });
    }
    // spg select 후 전력 정보 추출
    function onClickSpg(val, list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${val.companySpgId}/elecinfos/type`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (list) {
                        // data1의 value를 data2의 selectedUnit에 넣기
                        const updatedData2 = data.body.map((item2, idx) => {
                            const matchingItem1 = list.find((item1) => item1.code === item2.code);
                            if (matchingItem1) {
                                return Object.assign(Object.assign({}, item2), { value: matchingItem1.value, checked: matchingItem1.unit === null ? true : false, idx: idx, unit: item2.type < 2
                                        ? item2.unit
                                        : item2.unit.map((value, index) => ({
                                            name: value,
                                            selected: false,
                                            id: idx,
                                            unitId: value[0] + index,
                                        })), unitEn: item2.type < 2
                                        ? item2.unitEn
                                        : item2.unitEn.map((value, index) => ({
                                            name: value,
                                            selected: false,
                                            id: idx,
                                            unitEnId: value[0] + index,
                                        })) });
                            }
                            return item2;
                        });
                        setEleInfo(updatedData2);
                        updatedData2
                            .filter((val) => val.checked && val.value)
                            .map((element) => __awaiter(this, void 0, void 0, function* () {
                            yield ElecInfo(val.companySpgId, element, list);
                        }));
                    }
                    else {
                        setEleInfo(data.body.map((item, idx) => (Object.assign(Object.assign({}, item), { value: item.type < 2 ? "" : langIds < 2 ? item.unit[0] : item.unitEn[0], idx: idx, 
                            // uiType: item.type,
                            unit: item.type < 2
                                ? item.unit
                                : item.unit.map((value, index) => ({
                                    name: value,
                                    selected: false,
                                    id: idx,
                                    unitId: value[0] + index,
                                })), unitEn: item.type < 2
                                ? item.unitEn
                                : item.unitEn.map((value, index) => ({
                                    name: value,
                                    selected: false,
                                    id: idx,
                                    unitEnId: value[0] + index,
                                })), checked: false }))));
                    }
                    setSpg(val);
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    // elecInfo type2
    function onClickElecInfo(item, list, id, unitId, blooean) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${spg.companySpgId}/elecinfos/type`,
                appQuery: {
                    name: list.name,
                    elecCode: item.code,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    let itemArr = elecInfo.map((smenu) => smenu.code === item.code
                        ? Object.assign(Object.assign({}, smenu), { checked: true, value: list.name, unit: smenu.type < 2
                                ? smenu.unit
                                : smenu.unit.map((item) => item.id === id ? Object.assign(Object.assign({}, item), { selected: item.unitId == unitId ? true : false }) : item), unitEn: smenu.type < 2
                                ? smenu.unitEn
                                : smenu.unitEn.map((item) => item.id === id ? Object.assign(Object.assign({}, item), { selected: item.unitId == unitId ? true : false }) : item) }) : smenu);
                    const selcetItem = data.body.map((item) => (Object.assign(Object.assign({}, item), { value: "", 
                        // uiType: 3,
                        id: id })));
                    const listArr = itemArr.concat(selcetItem).sort((a, b) => (a.sort > b.sort ? 1 : -1));
                    const elecInfoListArr = (data) => {
                        const uniqueItems = new Set();
                        return data.filter((item) => {
                            const itemString = JSON.stringify(item);
                            if (uniqueItems.has(itemString)) {
                                return false;
                            }
                            else {
                                uniqueItems.add(itemString);
                                return true;
                            }
                        });
                    };
                    // 중복 제거된 데이터
                    const uniqueData = elecInfoListArr(listArr);
                    if (blooean) {
                        const dataArr = uniqueData.filter((item) => item.id !== id);
                        const changeData = dataArr.concat(selcetItem).sort((a, b) => (a.sort > b.sort ? 1 : -1));
                        setEleInfo(changeData);
                    }
                    else {
                        setEleInfo(uniqueData);
                    }
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    //팝업 시작시 첫 매핑옵션 가져오기
    function ElecInfo(companySpgId, list, value) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${companySpgId}/elecinfos/type`,
                appQuery: {
                    name: list.value,
                    elecCode: list.code,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    const listData2 = data.body.map((item2) => {
                        const matchingItem1 = value.find((item1) => item1.name === item2.elecInfoName);
                        if (matchingItem1) {
                            return Object.assign(Object.assign({}, item2), { value: matchingItem1.value, id: list.idx });
                        }
                        return item2;
                    });
                    if (listData2.length > 0) {
                        setEleInfoItem((item) => [...item, listData2]);
                    }
                    return data;
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    function PopClose(id) {
        CUTIL.IdScrollIntoView(id, "form__input");
        setItemName(popItem.itemName);
        setPanelName(popItem.panelName);
        setSerialNo(popItem.serialNo);
        setManufacturer(popItem.manufacturer);
        setMemo(popItem.memo);
        setToday(popItem.madeyyyyMM ? popItem.madeyyyyMM : "");
        setEditReload(true);
        CUTIL.jsclose_Popup(id);
    }
    // 전력정보 등록
    function ElecIfoChange(e, id) {
        setEleInfo(elecInfo.map((smenu) => (smenu.companyElecId === id ? Object.assign(Object.assign({}, smenu), { value: e.target.value }) : smenu)));
    }
    function itemEditClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            let itemArr = [];
            for (let i = 0; i < elecInfo.length; i++) {
                itemArr.push({
                    elecCode: elecInfo[i].code,
                    value: elecInfo[i].value,
                });
            }
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/product/item/${itemId.id}`,
                appQuery: {
                    roomId: curTree.room.roomId,
                    spgName: spg.spgName,
                    itemName: itemName,
                    panelName: panelName,
                    serialNo: serialNo,
                    manufacturer: manufacturer,
                    madeyyyyMM: dayjs(today).format("YYYYMM").toString(),
                    memo: memo,
                    elecInfo: itemArr,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (file.length > 0) {
                        uploadFileImage(data.body.itemIdPk);
                    }
                    else {
                        setReloadState(true);
                        PopClose("pop-s-edit");
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-s-edit", type: CONST.TYPE_INNRE, divTag: t("라벨.기기가수정되었습니다") }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-s-edit");
                        setReloadState(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
                else {
                    // need error handle
                    setErrorList(data.errorList);
                    document.getElementById(data.errorList[0].field).focus();
                    // document.getElementById("inp28").focus()
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    let ImageUi = [...updateFile, ...file];
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제 API
    function ImgDelete(img) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/image/${img.imageId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadState(true);
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-info", type: CONST.TYPE_ERROR, divTag: data.body }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setReloadState(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // setErrorList(data.errorList)
                }
            }
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(img, index) {
        if (img.imageId) {
            ImgDelete(img);
        }
        else {
            setFile(file.filter((_, idx) => idx !== index));
        }
    }
    // 첨부파일 업로드
    function uploadFileImage(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let appPath = `?itemId=${itemId}`;
            const formData = new FormData();
            // 파일 데이터 저장
            file.map((files) => formData.append("files", files));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/images/item${appPath}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setFile([]);
                    setReload(true);
                    PopClose("pop-s-edit");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-s-edit", type: CONST.TYPE_INNRE, divTag: t("라벨.기기가수정되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-s-edit");
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                        setErrorList(data.errorList);
                        setRecoilIsLoadingBox(false);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function onChangeItem(e) {
        setErrorList(errorList.filter((err) => err.field !== "itemName"));
        setItemName(e.target.value);
    }
    function onChangePanel(e) {
        setErrorList(errorList.filter((err) => err.field !== "panelName"));
        setPanelName(e.target.value);
    }
    function onChangeSerialNo(e) {
        setErrorList(errorList.filter((err) => err.field !== "serialNo"));
        setSerialNo(e.target.value);
    }
    function onChangeManufacturer(e) {
        setErrorList(errorList.filter((err) => err.field !== "manufacturer"));
        setManufacturer(e.target.value);
    }
    function onChangeTodayMonth(e) {
        setErrorList(errorList.filter((err) => err.field !== "madeyyyyMM"));
        if (e.target.value.length <= 7) {
            setToday(e.target.value);
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body pb-0" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: curTree.company.companyName + " " + curTree.zone.zoneName }), _jsx("li", { children: curTree.subZone.subZoneName ? curTree.subZone.subZoneName : t("라벨.전체") }), _jsx("li", { children: curTree.room.roomId ? curTree.room.roomName : t("라벨.전체") })] })), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [_jsx("h2", { children: t("라벨.설비정보") }), !editReload && (_jsxs("ul", Object.assign({ className: "form__input scrollH h440 pb-30" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.분전소명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp26", defaultValue: popItem && popItem.roomName, readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select spg ${errorList.filter((err) => err.field === "companyId").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: spg && spg.spgName })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: spgInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg(info, null) }, { children: info.spgName }), "spgInfo_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.형명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { className: `${errorList.filter((err) => err.field === "itemName").length > 0 ? " input-error" : ""}`, type: "text", id: "itemName", placeholder: t("라벨.텍스트입력"), value: itemName || "", onChange: (e) => onChangeItem(e) }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "itemName").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.판넬명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "panelName").length > 0 ? " input-error" : ""}`, type: "text", id: "panelName", placeholder: t("라벨.텍스트입력"), value: panelName || "", onChange: (e) => onChangePanel(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "panelName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.시리얼번호") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "serialNo").length > 0 ? " input-error" : ""}`, type: "text", id: "serialNo", placeholder: t("라벨.텍스트입력"), value: serialNo || "", onChange: (e) => onChangeSerialNo(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "serialNo").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제조사") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { className: `${errorList.filter((err) => err.field === "manufacturer").length > 0 ? " input-error" : ""}`, type: "text", id: "manufacturer", placeholder: t("라벨.텍스트입력"), value: manufacturer || "", onChange: (e) => onChangeManufacturer(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.제조년월") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "madeyyyyMM").length > 0 ? " input-error" : ""}`, type: "text", id: "madeyyyyMM", placeholder: t("라벨.제조년월입력"), value: today.toString().replace(/(\d{4})(\d{2})/, "$1-$2"), onChange: (e) => onChangeTodayMonth(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "madeyyyyMM").map((err) => err.msg) }))] }))] }), elecInfo.map((item, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: `tit mt-0` }, { children: [langIds > 1 ? item.elecInfoNameEnglish : item.elecInfoName, " ", item.type < 2 && `(${item.unit})`, _jsx("br", {}), _jsxs("span", Object.assign({ className: "fontRegular" }, { children: ["(", item.code, ")"] }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: item.type < 2 ? (_jsx("input", { type: "text", id: "inp_" + idx, value: item.value || "", onChange: (e) => ElecIfoChange(e, item.companyElecId) })) : (
                                                // {(errorList.filter(err => (err.field === "companyId")).length > 0) ? " input-error" : ""}
                                                _jsxs("div", Object.assign({ className: `select elecinfo_${idx}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: item.value })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: langIds > 1
                                                                ? item.unitEn.map((list, index) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickElecInfo(item, list, item.idx, list.unitId, item.checked) }, { children: list.name }), "unitEn_" + index.toString())))
                                                                : item.unit.map((list, index) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickElecInfo(item, list, item.idx, list.unitId, item.checked) }, { children: list.name }), "unit_" + index.toString()))) })] }))) }))] }, "lsinfoEdit_" + idx.toString()))), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: _jsx("span", { children: t("라벨.첨부파일") }) })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", placeholder: t("라벨.사진첨부하세요"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file1" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", accept: "image/*", id: "file1", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부120MB") })), ImageUi.map((img, idx) => (_jsx("ul", Object.assign({ className: "filelist" }, { children: _jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(img, idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }) }), "imgs_" + idx.toString())))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.설비메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [memo ? memo.length : "0", " / 400"] }))] }))] })] })))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => PopClose("pop-s-edit") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => itemEditClick(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function ItemPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [reload, setReload] = useRecoilState(reLoadPage);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const langIds = useRecoilValue(langId);
    const langs = useRecoilValue(langState);
    // props
    const { curTree, itemId, handleOpenPop, popReset, setPopreset, isMobile } = props;
    const [chnanTree, setChnanTree] = useState(null);
    const [itemList, setItemList] = useState([]);
    const [checkingItem, setCheckingItem] = useState([]);
    const [newAdd, setNewAdd] = useState(false);
    const [checkTypeItem, setChecktypeItem] = useState([]);
    const [checkSub, setCheckSub] = useState("");
    const [checkSubTypeItem, setCheckSubtypeItem] = useState([]);
    const [checkVersion, setCheckVersion] = useState("");
    const [checkVersionTypeItem, setCheckVersiontypeItem] = useState([]);
    const [today, setToday] = useState(null);
    const automaticCheckCycle = [
        { cycleNo: t("라벨.없음"), value: 0 },
        { cycleNo: t("라벨.T_일", ["30"]), value: 30 },
        { cycleNo: t("라벨.T_일", ["60"]), value: 60 },
        { cycleNo: t("라벨.T_일", ["90"]), value: 90 },
        { cycleNo: t("라벨.T_일", ["180"]), value: 180 },
        { cycleNo: t("라벨.T_일", ["365"]), value: 365 },
    ];
    const [schduleAdd, setSchduleAdd] = useState({
        checkVersionId: -1,
        isOutSource: false,
        period: null,
        inspector: userInfo.userName,
    });
    const [memo, setMemo] = useState("");
    const [errorList, setErrorList] = useState([]);
    // 페이지
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    let appPath = "zoneId=" + curTree.zone.zoneId;
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.totalElements}`;
    // 기기목록 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/items?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChnanTree(curTree);
                setItemList(data.body.filter((listf) => listf.id == itemId.id));
                setCheckingItem(data.body.filter((listf) => listf.id == itemId.id));
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10; //5, 10
                // 초기화
                if (popReset) {
                    setToday(null);
                    setCheckingItem([]);
                    setChecktypeItem([]);
                    setCheckSubtypeItem([]);
                    setCheckVersiontypeItem([]);
                    setSchduleAdd({
                        checkVersionId: -1,
                        isOutSource: false,
                        period: null,
                        inspector: userInfo.userName,
                    });
                    setMemo("");
                    setCheckSub("");
                    setErrorList([]);
                    setNewAdd(false);
                    setPopreset(false);
                }
            }
            else {
                // need error handle
                /*     setAlert({
                      ...alert,
                      type: CONST.TYPE_NONE,
                      divTag: data.errorList.map((err) => (err.msg))
                    });
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT); */
            }
        }
    }, [data, itemId, popReset, langIds]);
    // 체크박스 전체
    function CheckedAll(checked) {
        // spg 했을 시 활성화
        if (checked) {
            const checkedArray = [];
            itemList.forEach((list) => {
                checkedArray.push(list);
            });
            setCheckingItem(checkedArray);
        }
        else {
            setCheckingItem([]);
        }
    }
    // checkbox
    function CheckedList(checked, list) {
        // spg 했을 시 중복 가능
        if (checked) {
            setCheckingItem([...checkingItem, list]);
        }
        else {
            setCheckingItem(checkingItem.filter((el) => el !== list));
        }
    }
    // 진단 유형
    function CheckTypes(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (itemId.spgId || checkingItem.filter((type) => type.companySpgId).length > 0) {
                CUTIL.onClickSelect(e, CUTIL.selectOption);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktypes?companySpgId=${itemId.spgId}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setChecktypeItem(data.body);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.점검기기를선택해주세요") }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
        });
    }
    // 상세 유형
    function CheckTypeSub(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkType" && err.field !== "checkSub"));
            let data = null;
            // 진단 유형 초기화
            if (!checkSub || checkSub == type.description) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckSubtypeItem(data.body);
                        setCheckSub(type.description);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                setCheckSubtypeItem([]);
                setCheckVersiontypeItem([]);
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckSubtypeItem(data.body);
                        setCheckSub(type.description);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    // 버젼
    function CheckTypeVersion(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setErrorList(errorList.filter((err) => err.field !== "checkType" && err.field !== "checkSub"));
            setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { checkVersionId: -1 }));
            let data = null;
            // 상세 유형 초기화
            if (!checkVersion || checkVersion == type.checkSubName) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckVersiontypeItem(data.body);
                        setCheckVersion(type.checkSubName);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                setCheckVersiontypeItem([]);
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckVersiontypeItem(data.body);
                        setCheckVersion(type.checkSubName);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    // 버젼 선택
    function CheckTypeVersionSel(type) {
        setErrorList(errorList.filter((err) => err.field !== "checkVersionId"));
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { checkVersionId: type.checkVersionId }));
    }
    // 점검 일자
    function onChangeToday(date) {
        setErrorList(errorList.filter((err) => err.field !== "dueDate"));
        setToday(date);
    }
    // 자동 점검주기
    function automaticCheckCycleClick(acc) {
        setErrorList(errorList.filter((err) => err.field !== "period"));
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { period: acc.value }));
    }
    // 점검자
    function onChangInspector(e) {
        setErrorList(errorList.filter((err) => err.field !== "inspector"));
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { inspector: e.target.value }));
    }
    function SchdeulerAddpop(e) {
        handleOpenPop("pop-confirm", _jsx(ConfirmPop, { id: "pop-s-add", type: "today", clickfn: SchdeulerAdd }));
        CUTIL.jsopen_InnerPopup(CONST.POP_CONFIRM, "pop-s-add");
    }
    // 점검 예약 등록
    function SchdeulerAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            if (!checkSub ||
                !checkVersion ||
                schduleAdd.checkVersionId <= 0 ||
                schduleAdd.period == null ||
                !schduleAdd.inspector ||
                !today) {
                setErrorList([
                    !checkSub && { field: "checkType", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !checkVersion && { field: "checkSub", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    schduleAdd.checkVersionId <= 0 && { field: "checkVersionId", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !today && { field: "dueDate", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    schduleAdd.period == null && { field: "period", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                    !schduleAdd.inspector && { field: "inspector", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                ]);
                setRecoilIsLoadingBox(false);
            }
            else {
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: `/schedule`,
                    appQuery: {
                        dueDate: dayjs(today).format("YYYYMMDD").toString(),
                        itemId: itemId.id,
                        checkVersionId: schduleAdd.checkVersionId,
                        isOutSource: !schduleAdd.isOutSource,
                        period: schduleAdd.period,
                        inspector: schduleAdd.inspector,
                        memo: memo,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setReload(true);
                        CUTIL.jsclose_Popup("pop-ss-add");
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.예약이등록되었습니다") }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                    }
                    else {
                        // need error handle
                        setErrorList(data.errorList);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: curTree.company.companyName + " " + curTree.zone.zoneName + " " + curTree.subZone.subZoneName }), _jsx("li", { children: curTree.room.roomId ? curTree.room.roomName : t("라벨.전체") }), _jsx("li", { children: curTree.spg.spgBoolean ? curTree.spg.spgName : t("라벨.전체") })] })), _jsxs("div", Object.assign({ className: "flex-row" }, { children: [_jsxs("div", Object.assign({ className: "pop-left flex-1-4", style: { display: newAdd ? "none" : "" } }, { children: [_jsx("div", Object.assign({ className: "tbl-list tbl-select scrollH" }, { children: _jsxs("table", Object.assign({ summary: "\uC120\uD0DD, \uD615\uBA85, \uD310\uB12C\uBA85, \uC2DC\uB9AC\uC5BC\uBC88\uD638 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC124\uBE44\uC6A9 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC124\uBE44\uC6A9 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "m-none" }, { children: [_jsx("col", { style: { width: "50px" } }), _jsx("col", { style: { width: "28%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: {} })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", Object.assign({ scope: "col", className: "txt-left w10p" }, { children: [_jsx("input", { type: "checkbox", id: "st_all", checked: checkingItem.length === 0 ? false : checkingItem.length === itemList.length ? true : false, onChange: (e) => CheckedAll(e.target.checked) }), _jsx("label", Object.assign({ htmlFor: "st_all" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("th", Object.assign({ scope: "col", className: `m-none` }, { children: _jsx("span", { children: t("라벨.형명") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.판넬명") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.시리얼번호") }) }))] }) }), _jsx("tbody", { children: itemList.length > 0 ? (itemList.map((list, idx) => (_jsxs("tr", { children: [_jsxs("td", { children: [_jsx("input", { type: "checkbox", id: "st_" + idx, checked: checkingItem.includes(list) ? true : false, onChange: (e) => CheckedList(e.target.checked, list) }), _jsx("label", Object.assign({ htmlFor: "st_" + idx }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] }), _jsx("td", Object.assign({ className: `m-none ${list.itemName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.itemName }, { children: _jsx("p", Object.assign({ className: "ellipsis " }, { children: list.itemName })) })), _jsx("td", Object.assign({ className: `${list.panelName.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.panelName }, { children: _jsx("p", Object.assign({ className: "ellipsis " }, { children: list.panelName })) })), _jsx("td", Object.assign({ className: `${list.serialNo.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.serialNo }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.serialNo })) }))] }, "item_pop" + idx.toString())))) : (_jsx("tr", { children: _jsx("td", Object.assign({ colSpan: isMobile ? 3 : 4 }, { children: _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("라벨.조회된설비가없습니다") })) })) })) })] })) })), _jsx("div", Object.assign({ className: "tbl__bottom" }, { children: _jsxs("p", Object.assign({ className: "result__num" }, { children: [_jsxs("span", { children: [checkingItem.length, "/", itemList.length] }), t("라벨.선택됨")] })) }))] })), _jsxs("div", Object.assign({ className: "pop-right flex-1 m-none", id: "m-click-show0" }, { children: [_jsx("h2", { children: t("라벨.진단설정") }), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [newAdd ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_type  ${errorList.filter((err) => err.field === "checkType").length > 0 ? " input-error" : ""} `, onClick: (e) => CheckTypes(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkTypeItem &&
                                                                            checkTypeItem
                                                                                .filter((non) => non.checkTypeId != 4)
                                                                                .map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeSub(type) }, { children: type.description }), "typeInfo_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkType").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${checkSubTypeItem.length <= 0 ? "disabled" : ""}` }, { children: t("라벨.상세유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [checkSubTypeItem.length <= 0 ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_subtype ${errorList.filter((err) => err.field === "checkSub").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkSubTypeItem &&
                                                                            checkSubTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersion(type) }, { children: type.checkSubName }), "subtypeInfo_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkSub").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${checkVersionTypeItem.length <= 0 ? "disabled" : ""}` }, { children: t("라벨.버전") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [checkVersionTypeItem.length <= 0 ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_ver ${errorList.filter((err) => err.field === "checkVersionId").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.클릭선택") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkVersionTypeItem &&
                                                                            checkVersionTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersionSel(type) }, { children: type.versionNo }), "subVersionInfo_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "checkVersionId").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검예정일") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx(DatePicker, { className: `calendar ${errorList.filter((err) => err.field === "dueDate").length > 0 ? " input-error" : ""}`, locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: newAdd ? null : today, onChange: (date) => onChangeToday(date), 
                                                                // onFocus={(e) => e.target.readOnly = true} // 모바일 키보드 제거
                                                                withPortal: isMobile ? true : false, 
                                                                // readOnly={(dateSel != 0) ? true : false}  // 직접 입력 이외 입력 제한
                                                                minDate: new Date(), disabled: newAdd ? true : false, placeholderText: t("라벨.점검예정일선택") }), _jsx("p", Object.assign({ className: "input-errortxt", style: {
                                                                    display: errorList.filter((err) => err.field === "dueDate").length > 0 ? "block" : "none",
                                                                } }, { children: errorList.filter((err) => err.field === "dueDate").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.자동점검주기") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [newAdd ? (_jsx("input", { type: "text", id: "inp2", disabled: true })) : (_jsxs("div", Object.assign({ className: `select diagnosis_auto ${errorList.filter((err) => err.field === "period").length > 0 ? " input-error" : ""}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !popReset ? t("라벨.점검주기를선택해주세요") : "" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: automaticCheckCycle.map((acc, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => automaticCheckCycleClick(acc) }, { children: acc.cycleNo }), "ACC_" + idx.toString()))) })] }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "period").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검자") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "inspector").length > 0 ? " input-error" : ""}`, type: "text", id: "inp3", placeholder: newAdd ? "" : t("라벨.텍스트입력"), value: newAdd ? "" : schduleAdd.inspector, onChange: (e) => onChangInspector(e), disabled: newAdd ? true : false }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "inspector").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit ${newAdd ? "disabled" : ""}` }, { children: t("라벨.점검메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: newAdd ? "" : t("라벨.텍스트입력"), value: newAdd ? "" : memo, onChange: (e) => setMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo), disabled: newAdd ? true : false }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [newAdd ? "0" : memo.length, " / 400"] }))] }))] })] }))] }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [!isMobile && (_jsx("button", Object.assign({ type: "button", className: "js-open m-none", "data-pop": "pop-confirm", onClick: (e) => SchdeulerAddpop(e) }, { children: _jsx("span", { children: checkingItem.length > 0 ? t("라벨.저장") : t("라벨.확인") }) }))), isMobile && (_jsx("button", Object.assign({ type: "button", className: "m-click-show0", "data-pop": "m-click-show0", onClick: (e) => CUTIL.mClickShow(e) }, { children: _jsx("span", { children: t("라벨.다음") }) }))), isMobile && (_jsx("button", Object.assign({ type: "button", className: "bg-white go-prev m-none" }, { children: _jsx("span", { children: t("라벨.뒤로") }) }))), isMobile && (_jsxs("button", Object.assign({ type: "button", className: "go-save m-none", onClick: (e) => SchdeulerAddpop(e) }, { children: [" ", _jsx("span", { children: checkingItem.length > 0 ? t("라벨.저장") : t("라벨.확인") })] })))] }))] }));
}
function ChechItemUpdatepop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const itemId = useRecoilValue(itemInfoState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoadPage);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    const langs = useRecoilValue(langState);
    // props
    const { curTree, checkEdit, setCheckEdit, checkChange, setCheckChange, isMobile } = props;
    // useState
    const [checkTypeItem, setChecktypeItem] = useState([]);
    const [checkSubTypeItem, setCheckSubtypeItem] = useState([]);
    const [checkVersionTypeItem, setCheckVersiontypeItem] = useState([]);
    const [checkTypeBoolean, setCheckTypeBoolean] = useState(false);
    const [subCheckTypeBoolean, setSubCheckTypeBoolean] = useState(false);
    const [checkType, setCheckType] = useState("");
    const [subCheckType, setSubCheckType] = useState("");
    const [today, setToday] = useState(null);
    const automaticCheckCycle = [
        { cycleNo: t("라벨.없음"), value: 0 },
        { cycleNo: t("라벨.T_일", ["30"]), value: 30 },
        { cycleNo: t("라벨.T_일", ["60"]), value: 60 },
        { cycleNo: t("라벨.T_일", ["90"]), value: 90 },
        { cycleNo: t("라벨.T_일", ["180"]), value: 180 },
        { cycleNo: t("라벨.T_일", ["365"]), value: 365 },
    ];
    const [schduleAdd, setSchduleAdd] = useState({
        checkVersionId: -1,
        isOutSource: false,
        period: null,
        inspector: "",
        scheduleId: -1,
    });
    const [memo, setMemo] = useState("");
    // 체크리스트 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checktypes?companySpgId=${itemId.spgId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: checkEdit + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChecktypeItem(data.body);
                setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { inspector: checkEdit ? checkEdit.inspector : "", scheduleId: checkEdit ? checkEdit.scheduleId : "", period: checkEdit ? checkEdit.period : "" }));
                setMemo(checkEdit ? checkEdit.memo : "");
                setToday(new Date(checkEdit && checkEdit.dueDate));
                if (checkEdit) {
                    let types = null;
                    data.body.filter((cf) => cf.description === checkEdit.checkTypeName).map((type) => (types = type));
                    CheckTypeSub(types, false);
                    setCheckType(types.description);
                }
            }
            else {
                // need error handle
                /*    setAlert({
                     ...alert,
                     type: CONST.TYPE_NONE,
                     divTag: data.errorList.map((err) => (err.msg))
                   });
                   CUTIL.jsopen_AlertPopup(CONST.POP_ALERT); */
            }
        }
    }, [data, checkEdit, checkChange, langIds]);
    // 상세 유형
    function CheckTypeSub(type, boolean) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            // 진단 유형 초기화
            if (!boolean) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckSubtypeItem(data.body);
                        let types = null;
                        if (checkEdit) {
                            data.body.filter((cf) => cf.checkSubName === checkEdit.checkSubTypeName).map((type) => (types = type));
                            if (types) {
                                CheckTypeVersion(types, false);
                                setSubCheckType(types.checkSubName);
                            }
                        }
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                if (checkType !== type.checkTypeName) {
                    setCheckTypeBoolean(false);
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "GET",
                        appPath: `/checksheet/checktype/${type.checkTypeId}/checksubtypes`,
                        appQuery: {},
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            setCheckSubtypeItem(data.body);
                            setCheckType(type.checkTypeName);
                            setCheckTypeBoolean(true);
                            setCheckVersiontypeItem([]);
                        }
                        else {
                            // need error handle
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                }
                else {
                    setCheckType(type.checkTypeName);
                }
            }
        });
    }
    // 버젼
    function CheckTypeVersion(type, boolean) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            if (!boolean) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setCheckVersiontypeItem(data.body);
                        if (checkEdit) {
                            let types = null;
                            data.body.filter((cf) => cf.versionNo === checkEdit.checkVersionNo).map((type) => (types = type));
                            CheckTypeVersionSel(types);
                        }
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
            else {
                if (subCheckType !== type.checkSubName) {
                    setSubCheckTypeBoolean(false);
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "GET",
                        appPath: `/checksheet/checktype/checksubtype/${type.checkSubTypeId}/checkversions`,
                        appQuery: {},
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            setCheckVersiontypeItem(data.body);
                            setSubCheckType(type.checkSubName);
                            setSubCheckTypeBoolean(true);
                        }
                        else {
                            // need error handle
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                }
                else {
                    setSubCheckType(type.checkSubName);
                }
            }
        });
    }
    // 버젼 선택
    function CheckTypeVersionSel(type) {
        return __awaiter(this, void 0, void 0, function* () {
            setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { checkVersionId: type.checkVersionId }));
        });
    }
    // 자동 점검주기
    function automaticCheckCycleClick(acc) {
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { period: acc.value }));
    }
    function onChangInspector(e) {
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { inspector: e.target.value }));
    }
    // 점검 예약 수정
    function SchdeulerEdit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/schedule/${schduleAdd.scheduleId}`,
                appQuery: {
                    dueDate: dayjs(today).format("YYYYMMDD"),
                    checkVersionId: schduleAdd.checkVersionId,
                    isOutSource: !schduleAdd.isOutSource,
                    period: schduleAdd.period,
                    inspector: schduleAdd.inspector,
                    memo: memo,
                    completionDate: null,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.수정이완료되었습니다") }));
                    EditClose("pop-check-edit");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
            setReload(false);
        });
    }
    function EditClose(id) {
        CUTIL.jsclose_Popup(id);
        setCheckChange(false);
        setCheckTypeBoolean(false);
        setSubCheckTypeBoolean(false);
        setCheckEdit(null);
    }
    return (_jsxs(_Fragment, { children: [checkChange && (_jsxs("div", Object.assign({ className: "popup__body pb-0" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: curTree.company.companyName + " " + curTree.zone.zoneName + " " + curTree.subZone.subZoneName }), _jsx("li", { children: curTree.room.roomId ? curTree.room.roomName : t("라벨.전체") }), _jsx("li", { children: curTree.spg.spgBoolean ? curTree.spg.spgName : t("라벨.전체") })] })), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [_jsx("h2", { children: t("라벨.진단설정") }), _jsxs("ul", Object.assign({ className: "form__input scrollH h440 pb-30" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.점검유형") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select diagnosis_type", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: checkEdit
                                                                        ? checkTypeItem
                                                                            .filter((cf) => cf.description === checkEdit.checkTypeName)
                                                                            .map((type) => type.description)
                                                                        : t("라벨.클릭선택") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkTypeItem &&
                                                                checkTypeItem
                                                                    .filter((non) => non.checkTypeId != 4)
                                                                    .map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeSub(type, true) }, { children: type.description }), "typeInfo_" + idx.toString()))) })] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star` }, { children: t("라벨.상세유형") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select diagnosis_subtype", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: checkTypeBoolean
                                                                        ? t("라벨.클릭선택")
                                                                        : checkEdit &&
                                                                            checkSubTypeItem
                                                                                .filter((cf) => cf.checkSubName === checkEdit.checkSubTypeName)
                                                                                .map((type) => type.checkSubName) })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkSubTypeItem &&
                                                                checkSubTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersion(type, true) }, { children: type.checkSubName }), "subtypeInfo_" + idx.toString()))) })] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: `tit star ` }, { children: t("라벨.버전") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select diagnosis_ver", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: checkVersionTypeItem.length <= 0 || subCheckTypeBoolean
                                                                        ? t("라벨.클릭선택")
                                                                        : checkEdit &&
                                                                            checkVersionTypeItem
                                                                                .filter((cf) => cf.versionNo === checkEdit.checkVersionNo)
                                                                                .map((type) => type.versionNo) })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: checkVersionTypeItem &&
                                                                checkVersionTypeItem.map((type, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => CheckTypeVersionSel(type) }, { children: type.versionNo }), "version" + idx.toString()))) })] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.점검예정일") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx(DatePicker, { className: "calendar", locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: today, onChange: (date) => setToday(date), 
                                                    // onFocus={(e) => e.target.readOnly = true} // 모바일 키보드 제거
                                                    withPortal: isMobile ? true : false, 
                                                    // readOnly={(dateSel != 0) ? true : false}  // 직접 입력 이외 입력 제한
                                                    placeholderText: t("라벨.점검예정일선택") }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.자동점검주기") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select diagnosis_auto", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: checkEdit &&
                                                                        automaticCheckCycle
                                                                            .filter((accf) => accf.value == checkEdit.period)
                                                                            .map((acc) => acc.cycleNo) })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: automaticCheckCycle.map((acc, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => automaticCheckCycleClick(acc) }, { children: acc.cycleNo }), "ACC_" + idx.toString()))) })] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.점검자") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp3", placeholder: t("라벨.텍스트입력"), value: schduleAdd.inspector || "", onChange: (e) => onChangInspector(e) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.점검메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: t("라벨.텍스트입력"), value: memo || "", onChange: (e) => setMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [memo ? memo.length : "0", " / 400"] }))] }))] })] }))] }))] }))), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => EditClose("pop-check-edit") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SchdeulerEdit(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoadPage);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { checkEdit } = props;
    function MemoDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/schedule/${checkEdit.scheduleId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.jsclose_Popup("pop-delete");
                    let checkPop = document.querySelector(".popup-etc");
                    if (CUTIL.isnull(checkPop))
                        return;
                    checkPop.classList.remove("open");
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_INNRE, divTag: data.body }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
            setReload(false);
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.진단점검일정을삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            MemoDelete(e);
                        } }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
